export function formatValor (valor: number) {
  return 'R$ ' + Intl.NumberFormat('pt-br', {
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(valor)
}
